import React from 'react';

import { Modal, useModal } from 'components/complex/Modal';
import MainMenu from 'components/pagesComponents/landing/Main/components/MobileMenu/MainMenu';

export const MainMenuModal: React.FC = () => {
  const { modalProps } = useModal({
    type: 'MainMenu',
    width: '656px',
  });

  return (
    <Modal {...modalProps}>
      <MainMenu />
    </Modal>
  );
};
